import React, { useMemo } from 'react';
import { isOldBookingConfirmedTimestamp } from 'utils/booking';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import AlertBox from 'components/ui/AlertBox';
import { StyledAlertBox } from '../Leg.styles';
import { legShape } from 'constants/propTypes';

const isOldConfirmedTimestamp = (journey) =>
  journey.products.some((product) => isOldBookingConfirmedTimestamp(product.confirmedTimestamp)) || false;

const isThalysJourney = (journey) => journey.activeBookingItems.some((item) => item.code.startsWith('TH_MILES'));

const ThalysWorldBookingAlertBox = ({ journey, intl }) => {
  const showAlert = useMemo(() => isOldConfirmedTimestamp(journey) && isThalysJourney(journey), [journey]);

  if (!showAlert) {
    return null;
  }

  return (
    <StyledAlertBox
      variant={AlertBox.variants.ERROR}
      tooltips={{
        id: 'old-thalys-alert-tooltip',
        text: intl.formatMessage({ id: 'journeySegment.oldThalysBookingTooltip' })
      }}
    >
      <FormattedMessage id="journeySegment.oldThalysBooking" />
    </StyledAlertBox>
  );
};

ThalysWorldBookingAlertBox.propTypes = {
  journey: legShape.isRequired,
  intl: intlShape.isRequired
};

export default injectIntl(ThalysWorldBookingAlertBox);
